module.exports = __webpack_public_path__ + "img/imgVerify.30db99dd.png";